<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', 'CategorySubject')"
        v-b-toggle.sidebar-create-category-subject
        variant="primary"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>
    <template #cell(name)="{ data }">
      {{ $langName(data.value) }}
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-if="$can('update', 'CategorySubject')"
          :id="`category-subject-${data.item.id}-edit-icon`"
          v-b-toggle.sidebar-create-category-subject
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="updateCategory(data.item)"
        />

        <feather-icon
          v-if="$can('delete', 'CategorySubject')"
          :id="`category-subject-${data.item.id}-remove-icon`"
          icon="TrashIcon"
          size="16"
          class="mx-1 cursor-pointer"
          @click="removeCategory(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import categorySubjectModule from '@/store/category-subject/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH_CATEGORY_SUBJECT`)
  },
  methods: {
    removeCategory(category) {
      this.$removeSwal(this, category, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    updateCategory(category) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE_CATEGORY_SUBJECT`, category)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'categorySubject'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, categorySubjectModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(),
    }
  },
}
</script>

<style lang="scss">
</style>
